<template>
  <CRow>
    <CCol sm="12">
      <CCard class="p-5">
        <CRow>
          <CCol sm="2">
            <h4>Bill Generate </h4>
          </CCol>
          <CCol sm="10">
            <form v-on:submit.prevent="generateBill()">
              <CRow>
                <CCol sm="3" class="pr-0">
                  <label>Bill Generate Month</label>
                  <el-date-picker
                      :picker-options="pickerOptions"
                      required
                      class="w-100"
                      v-model="params.month"
                      type="month"
                      placeholder="Select Month"
                      :format="$monthPickerFormat"
                      value-format="yyyy-MM"
                  />
                </CCol>

                <CCol sm="3" class="pr-0">
                  <label>Issue Date</label>
                  <el-date-picker
                      @change="checkDueDate()"
                      required
                      class="w-100 p-0"
                      v-model="params.issue_date"
                      type="date"
                      placeholder="Enter Issue Date"
                      :format="$datePickerFormat"
                      value-format="yyyy-MM-dd"
                  />
                </CCol>

                <CCol sm="2" class="my-auto">
                  <button type="submit" class="btn btn-success w-100">Generate</button>
                </CCol>

                <CCol sm="4" class="my-auto">
                  <router-link class="btn btn-primary float-right" :to="{name:'BillList'}">
                    Generated Bill List
                  </router-link>
                </CCol>
              </CRow>
            </form>
          </CCol>
        </CRow>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "BillGenerate",
  data: () => {
    return {
      params: {
        issue_date: '',
        month: moment().clone().subtract(1, 'months').format('YYYY-MM'),
      },
      last_generate: moment().clone().subtract(1, 'months').format('YYYY-MM'),
      breadcrumbs: [{text: "Home", path: "/dashboard", isActive: false}, {
        text: "Bill Generate",
        path: "",
        isActive: true
      }]
    };
  },
  mounted() {
    this.fetchGenerateMonth()
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: this.disabledDate.bind(this),
      };
    },
  },
  methods: {
    disabledDate(time) {
      const lastGenerate = new Date(this.last_generate);
      return (
          time.getFullYear() === lastGenerate.getFullYear() &&
          time.getMonth() === lastGenerate.getMonth()
      );
    },
    fetchGenerateMonth() {
      axios.get(`/admin/fetch-generate-month/bill`).then(({data}) => {
        if (!data.status){
          this.last_generate = moment().clone().subtract(5, 'months').format('YYYY-MM');
          return;
        }
        this.last_generate = data.data.generate_year + '-' + data.data.generate_month
        const lastGenerateDate = moment(this.last_generate + '-01');
        this.params.month = lastGenerateDate.clone().add(1, 'month').format('YYYY-MM');
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.$store.dispatch("Settings/loading", false);
      })
    },
    checkDueDate(){
      axios.get(`/admin/check-due-date`, {params:{issue_date:this.params.issue_date}}).then(({data}) => {
        if (data.status =='error'){
          this.params.issue_date = ''
          return this.$toastr.e(
              data.status,
              data.message,
              data.title
          );
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    generateBill() {
      const formattedMonth = moment(this.params.month).format('MMMM-YYYY')
      this.$confirm({
        message: `Are you want to generate ${formattedMonth} month bill data?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch("Settings/loading", true);
            axios.post(`/admin/bill-generates`, this.params).then(({data}) => {
              if (data.status =='error'){
                return this.$toastr.e(
                    data.status,
                    data.message,
                    data.title
                );
              }
              this.$toastr.s(
                  data.status,
                  data.message,
                  data.title
              );

              this.$router.push({name:'BillList', query:{month:this.params.month}})

            }).catch((err) => {
              console.log(err);
            }).finally(()=>{
              this.$store.dispatch("Settings/loading", false);
            })
          }
        },
      });
    }
  },
  created() {
    this.$store.dispatch("Config/setBreadCrumb", this.breadcrumbs);
  },
};
</script>
